/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getItemSellTypeList } from '../fn/admin-item-sell-type-controller/get-item-sell-type-list';
import { GetItemSellTypeList$Params } from '../fn/admin-item-sell-type-controller/get-item-sell-type-list';
import { ItemSellTypeWithRelations } from '../models/item-sell-type-with-relations';

@Injectable({ providedIn: 'root' })
export class AdminItemSellTypeControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemSellTypeControllerGetItemSellTypeList()` */
  static readonly ItemSellTypeControllerGetItemSellTypeListPath = '/admin/item-sell-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getItemSellTypeList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getItemSellTypeList$Response(params?: GetItemSellTypeList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemSellTypeWithRelations>>> {
    return getItemSellTypeList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getItemSellTypeList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getItemSellTypeList(params?: GetItemSellTypeList$Params, context?: HttpContext): Observable<Array<ItemSellTypeWithRelations>> {
    return this.getItemSellTypeList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ItemSellTypeWithRelations>>): Array<ItemSellTypeWithRelations> => r.body)
    );
  }

}
